export default {
  STICK_TO_DESKTOP: {
    name: 'STICK_TO_DESKTOP',
    options: {
      path: '/',
      secure: true,
      httpOnly: false,
    },
  },
};
